<template>
  <v-card flat class="mt-4 mb-4 default-machine-card">
    <v-card-text class="pa-4 pt-2">
      <b-row>
        <b-col :md="6">
          <b-form-group
            id="item-default-machine-group"
            label-for="default-machine-input"
          >
            <template v-slot:label>
              <span class="font-weight-bold">
                {{ $t("LABELS.DEFAULT_MACHINE") }}
              </span>
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-1"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("LABELS.DEFAULT_MACHINE_FUEL_TOOLTIP") }}</span>
              </v-tooltip>
            </template>
            <v-autocomplete
              id="default-machine-input"
              :value="defaultMachine"
              :items="vehicles"
              item-text="name"
              return-object
              dense
              outlined
              clearable
              :placeholder="$t('LABELS.DEFAULT_MACHINE')"
              @input="$emit('update:defaultMachine', $event)"
            >
              <template v-slot:prepend-inner>
                <v-icon small color="grey">mdi-truck</v-icon>
              </template>
            </v-autocomplete>
          </b-form-group>
        </b-col>
        <b-col :md="6" class="d-flex align-items-center">
          <v-alert dense text type="info" class="mb-0" v-if="defaultMachine">
            <div class="d-flex align-items-center">
              <span>
                {{ $t("LABELS.DEFAULT_MACHINE_ACTIVE") }}
              </span>
            </div>
          </v-alert>
        </b-col>
      </b-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FuelExpenseFormDefaultMachine",
  props: {
    defaultMachine: {
      type: Object,
      default: null
    },
    vehicles: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.default-machine-card {
  border: 2px solid #e3f2fd;
  background-color: #fafafa;
}

.default-machine-card .v-card__title {
  background: linear-gradient(90deg, #e3f2fd 0%, #ffffff 100%);
}
</style>
